export default "__VITE_ASSET__BtN7Doq1__"